<template>
	<div class="flow-user-profile" :shape="shape" :style="styleObj">
		<slot>
			<span
				class="flow-user-profile-label"
				:style="{ fontSize: size / 2.5 + 'px', lineHeight: size / 3 + 'px' }"
			>
				{{ title }}
			</span>
		</slot>
	</div>
</template>
<script>
import { defineComponent } from "vue";

export default defineComponent({
	name: "Avatar",
	props: {
		/**
		 * label display in Avatar it should be max 2 characters
		 */
		label: {
			type: String,
			default: null
		},
		/**
		 * in pixels
		 */
		size: {
			type: Number,
			default: 36
		},
		/**
		 * 'circle' | 'square'
		 */
		shape: {
			type: String,
			default: "circle",
			validator(value) {
				return ["circle", "square"].includes(value);
			}
		}
	},
	data() {
		return {
			colors: [
				"#FFB900",
				"#D83B01",
				"#B50E0E",
				"#E81123",
				"#B4009E",
				"#5C2D91",
				"#0078D7",
				"#00B4FF",
				"#008272",
				"#107C10"
			]
		};
	},
	computed: {
		borderRadius() {
			if (this.shape === "circle") {
				return `${this.size / 2}px`;
			} else if (this.size <= 24) {
				return "2px";
			} else if (this.size > 24 && this.size <= 60) {
				return "4px";
			} else if (this.size > 60) {
				return "8px";
			}

			return "4px";
		},
		title() {
			if (this.label && this.label.length > 2) {
				return this.label.substring(0, 2);
			}
			return this.label;
		},
		background() {
			return this.hashCode(this.title);
		},
		styleObj() {
			return {
				backgroundColor: this.background,
				width: `${this.size}px`,
				height: `${this.size}px`,
				borderRadius: this.borderRadius
			};
		}
	},
	mounted() {
		this.colors = this.generateHslaColors(50, 60, 1.0, 10);
		//	console.log(this.colors);
	},
	methods: {
		hashCode(str) {
			// var hash = 0;
			// for (var i = 0; i < str.length; i++) {
			// 	hash = str.charCodeAt(i) + ((hash << 3) - hash);
			// }
			// return "#" + hash;

			let sum = 0;
			for (const index in str) {
				sum += str.charCodeAt(index);
			}
			//	console.log(this.colors[sum % this.colors.length]);
			return this.colors[sum % this.colors.length];
		},
		generateHslaColors(saturation, lightness, alpha, amount) {
			const colors = [];
			const huedelta = Math.trunc(360 / amount);

			for (let i = 0; i < amount; i++) {
				const hue = i * huedelta;
				// console.log(hue);
				colors.push(`hsla(${hue},${saturation}%,${lightness}%,${alpha})`);
			}
			return colors;
		}
	}
});
</script>
<style lang="scss">
div.flow-user-profile {
	overflow: hidden;
	display: inline-flex;
	align-items: center;
	justify-content: center;

	flex: 0 0 auto;

	span.flow-user-profile-label {
		// font-size: 12px;
		// line-height: 12px;
		color: var(--dashboard-background);
		font-weight: bold;
		text-transform: uppercase;
	}

	img {
		width: inherit;
		height: inherit;
	}
}
</style>
